var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.045,
    height: 15.238,
    viewBox: "0 0 17.045 15.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.073,12.063H13.068a1.006,1.006,0,0,1-1.005-1.005V10.052H4.021v1.005a1.006,1.006,0,0,1-1.005,1.005H2.01a1.006,1.006,0,0,1-1.005-1.005v-1.7A2.006,2.006,0,0,1,.5,8.042V6.534A2.008,2.008,0,0,1,1.2,5.026H.566A.375.375,0,0,1,.2,4.741L.012,3.987a.377.377,0,0,1,.365-.468h1.88L2.78,2.211A3.5,3.5,0,0,1,6.047,0H7.613C7.6.146,7.595.3,7.595.447A5.365,5.365,0,0,0,7.826,2.01H6.047a1.5,1.5,0,0,0-1.4.948L4.021,4.523H9.474a5.361,5.361,0,0,0,3.482,1.285,5.318,5.318,0,0,0,2.216-.478,1.971,1.971,0,0,1,.409,1.2V8.042a2,2,0,0,1-.5,1.317v1.7A1.006,1.006,0,0,1,14.073,12.063ZM13.068,6.031a1.927,1.927,0,0,0-1.508,1.5c0,.446.489.507,1.018.507.087,0,.175,0,.259,0l.231,0a.95.95,0,0,0,1.005-1A.95.95,0,0,0,13.068,6.031Zm-10.052,2h0l.23,0c.085,0,.172,0,.259,0a2.191,2.191,0,0,0,.7-.084.424.424,0,0,0,.319-.423,1.926,1.926,0,0,0-1.508-1.5.95.95,0,0,0-1.005,1,.95.95,0,0,0,1.005,1Z",
    transform: "translate(0 3.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.04,1.051v2.1C5.135,3.149,3,3.365,3,7.322c.377-1.406.864-2.209,4.04-2.209V7.4l3.176-3.177Z",
    transform: "translate(6.829 -1.051)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/Car.bece925907e6530bab1e4b3486dafb0a.svg";
export { ForwardRef as ReactComponent };